import React from "react";
import type {FunctionComponent} from "react";
import {useWhenDeviceLogic, WhenDeviceGroupType, WhenDeviceOsType} from "./WhenDevice.logic";

export interface IWhenDeviceProps {
  allowedType?: WhenDeviceGroupType | WhenDeviceGroupType[];
  blockedType?: WhenDeviceGroupType | WhenDeviceGroupType[];
  allowedOs?: WhenDeviceOsType | WhenDeviceOsType[];
  blockedOs?: WhenDeviceOsType | WhenDeviceOsType[];
}

export const WhenDevice: FunctionComponent<IWhenDeviceProps> = ({allowedType, blockedType, allowedOs, blockedOs, children}) => {
  const {isConditionPassed} = useWhenDeviceLogic({allowedType, blockedType, allowedOs, blockedOs});
  if (!isConditionPassed) {
    // conditions not passed, don't return anything
    return null;
  }
  return <>{children}</>;
}

